export const ZERO_ADDRESS = `0x${'0'.repeat(40)}`
export const EMPTY_DATA = '0x'
